import { LinkSVG } from './link'
import { ShoppingBagSVG } from './shopping-bag'
import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

export { LinkSVG } from './link'
export { ShoppingBagSVG } from './shopping-bag'

const getIcon = (
  icon: React.ComponentType<CustomIconComponentProps | React.SVGProps<SVGSVGElement>>,
  iconName: string,
  { className, ...props }: any
) => {
  return <Icon className={`gungnir-icon gungnir-icon-${iconName} ${className ?? ''}`} component={icon} {...props} />
}

export const Link = (props: any) => getIcon(LinkSVG, 'link', props)
export const ShoppingBag = (props: any) => getIcon(ShoppingBagSVG, 'shopping-bag', props)
